// extracted by mini-css-extract-plugin
module.exports = {"component":"CmsProductWhatsIncluded_component__N5_Tq","boxed":"CmsProductWhatsIncluded_boxed__5aHzU","repairs":"CmsProductWhatsIncluded_repairs__efZz1"};